<template>
    <div class="page-table tabStyle scrollable mainDiv" id="affix-container">
        <div class="page-header card-base card-shadow--small"
             style="height: 0; margin-bottom: 10px; padding: 12px 24px 24px;">
            <el-breadcrumb separator-class="el-icon-arrow-right" style="margin-top: 0">
                <el-breadcrumb-item :to="{ path: '/' }"><i class="mdi mdi-home-outline"></i></el-breadcrumb-item>
                <el-breadcrumb-item> {{$t("src.views.apps.urun.title")}}</el-breadcrumb-item>
                <el-breadcrumb-item> {{$t("src.views.apps.urun.duzenleme.title")}}
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="card-base baslikBg animated fadeInUp">{{$t("src.views.apps.urun.duzenleme.baslikH1")}}</div>
        <el-row :gutter="10">
            <el-form status-icon :model="urunForm" :rules="rulesUrun" ref="urunForm"
                     class="demo-ruleForm">
                <el-col :lg="18" :md="18" :sm="24" :xs="24">
                    <el-tabs tab-position="left" class="language">
                        <el-tab-pane>
                            <span slot="label"><i class="flag-icon flag-icon-tr"></i></span>
                            <div class="card-base card-shadow--medium demo-box bg-white animated fadeInLeft">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.urun.tanimlama.baslik")'
                                                      prop="baslik">:
                                            <div v-if="linkVisible" style="float: right; display: flex">
                                                <div v-if="!VisibleA">
                                                    <el-link target="_blank" :underline="false"
                                                             href="http://artdoor.com.tr/">
                                                        http://artdoor.com.tr/urunler/{{this.urunForm.link}}
                                                    </el-link>
                                                </div>
                                                <el-button v-if="duzenleBtnVisible"
                                                           style="margin-left: 10px; margin-bottom: 5px"
                                                           v-on:click="VisibleA = true;  duzenleBtnVisible=false"
                                                           size="mini">Düzenle
                                                </el-button>
                                                <span v-if="VisibleA">http://www.artdoor.com.tr/tr/ </span>
                                                <el-input v-if="VisibleA" v-model="urunForm.link"
                                                          v-on:change="linkChange = false"
                                                          v-on:blur="linkTespitLink();VisibleA=false; duzenleBtnVisible=true"
                                                          style="width: 50%" size="mini"></el-input>
                                            </div>
                                            <el-input
                                                    v-model="urunForm.baslik"
                                                    v-on:change="linkTespit"
                                                    :placeholder='$t("src.views.apps.sayfa.tanimlama.baslikPlace")'></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item
                                                :label='$t("src.views.apps.urun.kategori.tanimlama.urunKodu")'
                                                prop="urunKodu">
                                            <el-input disabled v-model="urunForm.urunKodu"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.altBaslik")'
                                                      prop="altBaslik">:
                                            <el-input
                                                    v-model="urunForm.altBaslik"
                                                    :placeholder='$t("src.views.apps.sayfa.tanimlama.altBaslikPlace")'></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.icerik")'
                                                      prop="icerik">:
                                            <ckeditor :editor="editor"
                                                      :config="editorConfig"
                                                      v-model="urunForm.icerik"
                                                      @input="seoIcerikTespit"
                                                      @blur="seoIcerikTespit"></ckeditor>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </div>
                            <el-collapse style="margin-top: 10px" v-model="activeCollapse">
                                <el-collapse-item title="Resim Ayarları" name="4">
                                    <el-row>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.resim")'
                                                          prop="resim">:
                                                <el-upload
                                                        class="resimler"
                                                        action=""
                                                        list-type="picture-card"
                                                        multiple
                                                        :file-list="imageListMain"
                                                        :auto-upload="false"
                                                        accept=".jpg,.jpeg,.png"
                                                        :on-change="imageUpload"
                                                        :on-preview="firstImage"
                                                        :on-remove="imageRemove">
                                                    <i slot="default" class="el-icon-plus"></i>
                                                </el-upload>
                                                <el-button style="margin-top: 15px;width: 150px;" type="primary"
                                                           v-on:click="serverImageList"
                                                           @click="dialogImgServerVisible = true; " size="mini">
                                                    Sunucudan
                                                    Seç
                                                </el-button>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-collapse-item>
                                <el-collapse-item title="Ürün Kategori Bilgileri" name="5">
                                    <el-row>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item
                                                    prop="kategoriList">
                                                <el-transfer
                                                        class="guncellemeTransfer"
                                                        v-model="urunForm.kategoriList"
                                                        filterable
                                                        :titles="['Kategori Listesi', 'Seçilen Kategoriler']"
                                                        @left-check-change="kategoriLeftChange"
                                                        @right-check-change="kategoriRightChange"
                                                        :format="{
                                                                noChecked: '${total}',
                                                                hasChecked: '${checked}/${total}'}"
                                                        :data="kategoriListesi">
                                                </el-transfer>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-collapse-item>
                                <el-collapse-item title="Ürün Opsiyon Bilgileri" name="6">
                                    <el-row>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item
                                                    prop="opsiyonList">
                                                <el-transfer
                                                        style="text-align: left; display: inline-block"
                                                        v-model="urunForm.opsiyonList"
                                                        filterable
                                                        :titles="['Opsiyon Listesi', 'Seçilen Opsiyonlar']"
                                                        :format="{
                                                                    noChecked: '${total}',
                                                                    hasChecked: '${checked}/${total}'}"
                                                        @change="opsiyonChange"
                                                        :data="opsiyonListesi">
                                                    <!--<el-button class="transfer-footer" slot="left-footer" type="primary"-->
                                                    <!--style="float: left; margin-top: 8px"-->

                                                    <!--@click="opsiyonDetayDialog = true" size="mini">Yeni-->
                                                    <!--Opsiyon-->
                                                    <!--</el-button>-->
                                                </el-transfer>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-collapse-item>
                                <el-collapse-item title="SEO Ayarları" name="7">
                                    <el-row>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item
                                                    :label='$t("src.views.apps.sayfa.tanimlama.seoBaslik")'
                                                    prop="seoBaslik">:
                                                <el-input
                                                        v-model="urunForm.seoBaslik"
                                                        maxlength="60"
                                                        show-word-limit
                                                        :placeholder='$t("src.views.apps.sayfa.tanimlama.seoBaslikPlace")'></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item
                                                    :label='$t("src.views.apps.sayfa.tanimlama.seoIcerik")'
                                                    prop="seoIcerik">:
                                                <el-input type="textarea"
                                                          maxlength="140"
                                                          v-on:focus="seoIcerikChange = false"
                                                          show-word-limit
                                                          v-model="urunForm.seoIcerik"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-collapse-item>
                            </el-collapse>
                        </el-tab-pane>
                        <el-tab-pane>
                            <span slot="label"><i class="flag-icon flag-icon-gb"></i></span>
                            <div class="card-base card-shadow--medium demo-box bg-white animated fadeInLeft">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item
                                                :label='$t("src.views.apps.sayfa.tanimlama.dil.en.baslik")'
                                                prop="dil.en.baslik">:
                                            <el-input
                                                    v-model="urunForm.dil.en.baslik"
                                                    v-on:change="urunForm.dil.en.seoBaslik = urunForm.dil.en.baslik.substring(0, 60)"
                                                    :placeholder='$t("src.views.apps.sayfa.tanimlama.baslikPlace")'></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item
                                                :label='$t("src.views.apps.sayfa.tanimlama.dil.en.altBaslik")'
                                                prop="dil.en.altBaslik">:
                                            <el-input
                                                    v-model="urunForm.dil.en.altBaslik"
                                                    :placeholder='$t("src.views.apps.sayfa.tanimlama.altBaslikPlace")'></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item
                                                :label='$t("src.views.apps.sayfa.tanimlama.dil.en.icerik")'
                                                prop="dil.en.icerik">:
                                            <ckeditor :editor="editor"
                                                      :config="editorConfig"
                                                      v-model="urunForm.dil.en.icerik"
                                                      @input="seoIcerikDilTespit"
                                                      @blur="seoIcerikDilTespit"></ckeditor>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </div>
                            <el-collapse style="margin-top: 10px" v-model="activeCollapse">
                                <el-collapse-item title="Resim Ayarları" name="4">
                                    <el-row>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.resim")'
                                                          prop="resim">:
                                                <el-upload
                                                        class="resimler"
                                                        action=""
                                                        list-type="picture-card"
                                                        multiple
                                                        :file-list="imageListMain"
                                                        :auto-upload="false"
                                                        accept=".jpg,.jpeg,.png"
                                                        :on-change="imageUpload"
                                                        :on-preview="firstImage"
                                                        :on-remove="imageRemove">
                                                    <i slot="default" class="el-icon-plus"></i>
                                                </el-upload>
                                                <el-button style="margin-top: 15px;width: 150px;" type="primary"
                                                           v-on:click="serverImageList"
                                                           @click="dialogImgServerVisible = true; " size="mini">
                                                    Sunucudan
                                                    Seç
                                                </el-button>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-collapse-item>
                                <el-collapse-item title="SEO Ayarları" name="6">
                                    <el-row>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item
                                                    :label='$t("src.views.apps.sayfa.tanimlama.seoBaslik")'
                                                    prop="dil.en.seoBaslik">:
                                                <el-input
                                                        v-model="urunForm.dil.en.seoBaslik"
                                                        maxlength="60"
                                                        show-word-limit
                                                        :placeholder='$t("src.views.apps.sayfa.tanimlama.seoBaslikPlace")'></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item
                                                    :label='$t("src.views.apps.sayfa.tanimlama.seoIcerik")'
                                                    prop="dil.en.seoIcerik">:
                                                <el-input type="textarea"
                                                          maxlength="140"
                                                          v-on:focus="seoIcerikIngChange = false"
                                                          show-word-limit
                                                          v-model="urunForm.dil.en.seoIcerik"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-collapse-item>
                            </el-collapse>
                        </el-tab-pane>
                        <el-tab-pane>
                            <span slot="label"><i class="flag-icon flag-icon-de"></i></span>
                            <div class="card-base card-shadow--medium demo-box bg-white animated fadeInLeft">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item
                                                :label='$t("src.views.apps.sayfa.tanimlama.dil.de.baslik")'
                                                prop="dil.de.baslik">:
                                            <el-input
                                                    v-model="urunForm.dil.de.baslik"
                                                    v-on:change="urunForm.dil.de.seoBaslik = urunForm.dil.de.baslik.substring(0, 60)"
                                                    :placeholder='$t("src.views.apps.sayfa.tanimlama.baslikPlace")'></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item
                                                :label='$t("src.views.apps.sayfa.tanimlama.dil.de.altBaslik")'
                                                prop="dil.de.altBaslik">:
                                            <el-input
                                                    v-model="urunForm.dil.de.altBaslik"
                                                    :placeholder='$t("src.views.apps.sayfa.tanimlama.altBaslikPlace")'></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item
                                                :label='$t("src.views.apps.sayfa.tanimlama.dil.de.icerik")'
                                                prop="dil.de.icerik">:
                                            <ckeditor :editor="editor"
                                                      :config="editorConfig"
                                                      v-model="urunForm.dil.de.icerik"
                                                      @input="seoIcerikDil2Tespit"
                                                      @blur="seoIcerikDil2Tespit"></ckeditor>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </div>
                            <el-collapse style="margin-top: 10px" v-model="activeCollapse">
                                <el-collapse-item title="Resim Ayarları" name="4">
                                    <el-row>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.resim")'
                                                          prop="resim">:
                                                <el-upload
                                                        class="resimler"
                                                        action=""
                                                        list-type="picture-card"
                                                        multiple
                                                        :file-list="imageListMain"
                                                        :auto-upload="false"
                                                        accept=".jpg,.jpeg,.png"
                                                        :on-change="imageUpload"
                                                        :on-preview="firstImage"
                                                        :on-remove="imageRemove">
                                                    <i slot="default" class="el-icon-plus"></i>
                                                </el-upload>
                                                <el-button style="margin-top: 15px;width: 150px;" type="primary"
                                                           v-on:click="serverImageList"
                                                           @click="dialogImgServerVisible = true; " size="mini">
                                                    Sunucudan
                                                    Seç
                                                </el-button>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-collapse-item>
                                <el-collapse-item title="SEO Ayarları" name="6">
                                    <el-row>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item
                                                    :label='$t("src.views.apps.sayfa.tanimlama.seoBaslik")'
                                                    prop="dil.de.seoBaslik">:
                                                <el-input
                                                        v-model="urunForm.dil.de.seoBaslik"
                                                        maxlength="60"
                                                        show-word-limit
                                                        :placeholder='$t("src.views.apps.sayfa.tanimlama.seoBaslikPlace")'></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item
                                                    :label='$t("src.views.apps.sayfa.tanimlama.seoIcerik")'
                                                    prop="dil.de.seoIcerik">:
                                                <el-input type="textarea"
                                                          maxlength="140"
                                                          v-on:focus="seoIcerikIngChange = false"
                                                          show-word-limit
                                                          v-model="urunForm.dil.de.seoIcerik"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-collapse-item>
                            </el-collapse>
                        </el-tab-pane>
                    </el-tabs>
                </el-col>
                <el-col :lg="6" :md="6" :sm="24" :xs="24">
                    <el-collapse class="yanForm animated fadeInUp delay-1s" v-model="activeCollapse">
                        <el-collapse-item name="1" :title='$t("src.views.apps.sayfa.tanimlama.durum")'>
                            <el-row>
                                <div>
                                    <el-button size="mini" class="onayBtn"
                                               v-on:click="urunGuncelleme('urunForm')"
                                               type="primary">
                                        {{$t('src.views.apps.sayfa.guncelleme.sayfaguncelle')}}
                                    </el-button>
                                    <el-button
                                            size="mini" @click="$router.go(-1)"
                                            class="onayBtn">
                                        Vazgeç
                                    </el-button>
                                </div>
                            </el-row>
                        </el-collapse-item>
                    </el-collapse>
                    <div v-for="(item,index) in secilenOpsiyonlar" :key="index">
                        <el-collapse class="yanForm animated fadeInUp delay-1s" v-model="activeCollapse">
                            <el-collapse v-model="collapseOps">
                                <el-row :gutter="10">
                                    <el-col :span="20">
                                        <el-collapse-item :title='item.label' :name="index" class="margin-top-10">
                                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p"
                                                    style="margin-top: 5px">
                                                <el-form-item :label='item.label'>:
                                                    <el-input
                                                            v-model="item.aciklama.tr"></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p"
                                                    style="margin-top: 5px">
                                                <el-form-item :label='item.label+" (İngilizce)"'>:
                                                    <el-input
                                                            v-model="item.aciklama.en"></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p"
                                                    style="margin-top: 5px">
                                                <el-form-item :label='item.label+" (Almanca)"'>:
                                                    <el-input
                                                            v-model="item.aciklama.de"></el-input>
                                                </el-form-item>
                                            </el-col>
                                        </el-collapse-item>
                                    </el-col>
                                    <el-col :span="4">
                                        <el-button type="danger" v-on:click="removeSecilen(index)" class="margin-top-20" size="mini" icon="mdi mdi-close"></el-button>
                                    </el-col>
                                </el-row>
                            </el-collapse>
                        </el-collapse>
                    </div>
                </el-col>
            </el-form>
            <el-dialog
                    title="Opsiyon Konumu"
                    :visible.sync="dialogKonum"
                    width="50%">
                <el-row>
                    <el-col :span="12">
                        <el-radio v-model="urunForm.opsiyonKonum" label="0" @change="changeKonum('0')">
                            <img src="../../../assets/images/13.png" alt="Alt" width="80%" height="80%">
                        </el-radio>
                    </el-col>
                    <el-col :span="12">
                        <el-radio v-model="urunForm.opsiyonKonum" label="1" @change="changeKonum('1')">
                            <img src="../../../assets/images/14.png" alt="Sağ" width="80%" height="80%">
                        </el-radio>
                    </el-col>
                </el-row>
            </el-dialog>
            <el-dialog
                    title='Sunucudan Fotoğraf Seç'
                    :visible.sync="dialogImgServerVisible"
                    width="60%"
                    center>
                <el-upload
                        action="#"
                        accept=".jpg,.jpeg,.png"
                        :on-change="serverImageUpload"
                        list-type="picture-card"
                        :file-list="imageListServer"
                        :auto-upload="false">
                    <i slot="default" class="el-icon-plus"></i>
                    <div slot="file" slot-scope="{file}">
                        <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
                        <span class="el-upload-list__item-actions">
                            <span class="el-upload-list__item-delete"
                                  @click="imageUploadtoServer(file)">
                                  <i class="el-icon-plus"></i>
                            </span>
                        </span>
                    </div>
                </el-upload>
            </el-dialog>
            <el-dialog
                    title="Opsiyon İçerik"
                    :visible.sync="opsiyonDetayVisible"
                    width="50%">
                <el-form :model="opsiyonForm" ref="opsiyonForm">
                    <el-row class="margin-top-10">
                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                            <el-form-item :label='$t("src.views.apps.urun.tanimlama.opsiyonBaslik")'>:
                                <el-input
                                        v-model="opsiyonForm.opsiyonBaslik"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                            <el-form-item :label='$t("src.views.apps.urun.tanimlama.opsiyonBaslikEn")'>:
                                <el-input
                                        v-model="opsiyonForm.opsiyonBaslikEn"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                            <el-form-item :label='$t("src.views.apps.urun.tanimlama.opsiyonBaslikDe")'>:
                                <el-input
                                        v-model="opsiyonForm.opsiyonBaslikDe"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                            <el-form-item prop="yapiskan">
                                <el-switch
                                        v-model="opsiyonForm.yapiskan"
                                        active-value="1"
                                        inactive-value="0"
                                        active-text="Sabitle"
                                        inactive-text="Sabitleme">
                                </el-switch>
                            </el-form-item>
                        </el-col>
                        <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                            <el-form-item :label='$t("src.views.apps.urun.tanimlama.opsiyonKonum")'
                                          prop="opsiyonKonum">:
                                <el-button type="primary" size="mini" @click="dialogKonum = true">
                                    Seç
                                </el-button>
                                &nbsp;
                                <img v-if="opsiyonForm.opsiyonKonum === '0'" style="float: right"
                                     src="../../../assets/images/13.png" width="20%" height="20%">
                                <img v-if="opsiyonForm.opsiyonKonum === '1'" style="float: right"
                                     src="../../../assets/images/14.png" width="20%" height="20%">
                            </el-form-item>
                        </el-col>
                        <!--<span slot="footer" class="dialog-footer">-->
                        <el-button type="primary" size="mini"
                                   @click="opsiyonTanimla('urunForm')">Opsiyon Tanımlama
                        </el-button>
                        <el-button size="mini" @click="opsiyonDetayVisible = false">Vazgeç</el-button>
                        <!--</span>-->
                    </el-row>
                </el-form>
            </el-dialog>
        </el-row>
    </div>
</template>

<script>
    import Vue from 'vue';
    import CKEditor from '@ckeditor/ckeditor5-vue';
    import JQuery from 'jquery';
    import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
    import '@ckeditor/ckeditor5-build-classic/build/translations/tr';

    Vue.use(CKEditor)
    import urunService from '../../../WSProvider/UrunService'
    import status from '../../../status'

    let $ = JQuery;
    let base64 = require('base64_js');
    let userDataArtdoor = "";
    export default {
        name: "UrunDuzenle",
        components: {
            ckeditor: CKEditor.component
        },
        mounted() {
            let state = false;
            if (localStorage.getItem("userDataArtdoor")) {
                userDataArtdoor = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataArtdoor"))));
                if (userDataArtdoor["tur"]) {
                    if (userDataArtdoor["tur"] === '1' || userDataArtdoor["tur"] === '2')
                        state = true;
                }
            }
            if (!state) {
                this.$store.commit('setLogout');
                this.$router.push("/login");
            } else {
                this.getKategoriListesi();
                this.getOpsiyonListesi();
                this.updateUrunKodu = window.location.search.slice(1).split("=")[1];
                this.getUrunDetay(this.updateUrunKodu);
            }
        },
        data() {
            return {
                dialogKonum: false,
                opsiyonDetayVisible: false,
                konumText: "Seç",
                limit: 0,
                updateUrunKodu: '',
                updateData: [],
                updateDataKat: [],
                updateDataOps: [],
                updateDataEN: [],
                updateDataDE: [],
                checkedKategori: [],
                checkedOpsiyon: [],
                urunDetayKlon: [],
                oldOpsiyonList: [],
                imageListServer: [],
                fileListServer: [],
                dialogImgServerVisible: false,
                dialogDocServerVisible: false,
                seoIcerikChange: true,
                seoIcerikIngChange: true,
                VisibleA: false,
                linkChange: true,
                linkVisible: false,
                duzenleBtnVisible: true,
                imageListMain: [],
                fileListMain: [],
                kategoriListesi: [],
                opsiyonListesi: [],
                secilenOpsiyonlar: [],
                secilenlerKlon: [],
                secilenOpsiyonlarPost: [],
                editor: ClassicEditor,
                editorConfig: {
                    language: 'tr'
                },
                activeCollapse: ['1', '2', '3', '4', '5', '6', '7'],
                collapseOps: ['1'],
                visibleSil: false,
                checked: true,
                urunForm: {
                    baslik: "",
                    altBaslik: "",
                    icerik: "",
                    link: '',
                    urunKodu: '',
                    seoBaslik: '',
                    seoIcerik: '',
                    resim: [],
                    kategoriList: [],
                    opsiyonList: [],
                    durum: "1",
                    dil: {
                        en: {
                            baslik: '',
                            altBaslik: '',
                            icerik: '',
                            seoBaslik: '',
                            seoIcerik: ''
                        },
                        de: {
                            baslik: '',
                            altBaslik: '',
                            icerik: '',
                            seoBaslik: '',
                            seoIcerik: ''
                        }
                    }
                },
                opsiyonForm: {
                    opsiyonBaslik: '',
                    opsiyonBaslikEn: '',
                    opsiyonBaslikDe: '',
                    yapiskan: '0',
                    opsiyonKonum: '1',
                },
                opsiyonAciklamaForm: {
                    opsiyonBaslik: [],
                    opsiyonBaslikEn: [],
                    opsiyonBaslikDe: [],
                },
                rulesUrun: {
                    baslik: [{
                        required: true,
                        message: " ",
                        trigger: 'change'
                    }],
                    ustKategori: [{
                        required: true,
                        message: " ",
                        trigger: 'blur'
                    }],
                    urunKodu: [{
                        required: true,
                        message: " ",
                        trigger: 'blur'
                    }],
                },
            }
        },
        methods: {
            linkTespitLink() {
                let self = this;
                if (this.urunForm.link) {
                    urunService.linkKontrol(self.urunForm.link.replace("'", "")).then((response) => {
                        if (response.status === 200) {
                            self.urunForm.link = response.data;
                        } else {
                            status.Status(response.status, this)
                        }
                    })
                }
            },
            linkTespit() {
                let self = this;
                if (this.linkChange) {
                    urunService.linkKontrol(self.urunForm.baslik.replace("'", "")).then((response) => {
                        if (response.status === 200) {
                            if (self.urunForm.baslik) {
                                self.urunForm.seoBaslik = self.urunForm.baslik.substring(0, 60);
                                if (response.status === 200) {
                                    self.linkVisible = true;
                                    self.urunForm.link = response.data;
                                }
                            } else if (!self.urunForm.baslik) {
                                self.linkVisible = false;
                                self.urunForm.link = '';
                                self.urunForm.seoBaslik = '';
                            }
                        } else {
                            status.Status(response.status, this)
                        }
                    })
                }
            },
            getKategoriListesi() {
                let self = this;
                urunService.kategoriList().then((response) => {
                    if (response.status === 200) {
                        response.data.forEach(function (e) {
                            let obj = self.kategoriListesi.find(data => data.key === e.urunKategoriKodu);
                            if (obj === undefined) {
                                self.kategoriListesi.push({
                                    key: e.urunKategoriKodu,
                                    label: e.baslik,
                                });
                            }
                        })
                    } else {
                        status.Status(response.status, this)
                    }
                })
            },
            getOpsiyonListesi() {
                let self = this;
                urunService.opsiyonList().then((response) => {
                    if (response.status === 200) {
                        response.data.forEach(function (e) {
                            let obj = self.opsiyonListesi.find(data => data.key === e.uOpsiyonKodu);
                            if (obj === undefined) {
                                self.opsiyonListesi.push({
                                    key: e.uOpsiyonKodu,
                                    label: e.baslik,
                                });
                            }
                        })
                    } else {
                        status.Status(response.status, this)
                    }
                })
            },
            getUrunDetay() {
                let self = this;
                urunService.urunDetay(this.updateUrunKodu).then((response) => {
                    if (response.status === 200) {
                        if (response.data['resim']) {
                            response.data['resim'].forEach(function (e) {
                                if (e) {
                                    self.imageListMain.push({
                                        name: e,
                                        url: urunService.imageUrlOrta + e
                                    });
                                }
                            });
                        }
                        if (response.data.kategori) {
                            response.data.kategori.forEach(function (e) {
                                self.urunForm.kategoriList.push(e.ukategoriKodu)
                            })
                        }
                        if (response.data.opsiyon) {
                            this.oldOpsiyonList = response.data.opsiyon;
                            response.data.opsiyon.forEach(function (e) {
                                self.urunForm.opsiyonList.push(e.uOpsiyonKodu);
                                self.secilenOpsiyonlar.push({
                                    opsiyonKodu: e.uOpsiyonKodu,
                                    label: e.baslik,
                                    aciklama: {
                                        tr: e.aciklama,
                                        en: e.dil.en.aciklama,
                                        de: e.dil.de.aciklama,
                                    }
                                });
                                self.secilenlerKlon = JSON.stringify(self.secilenOpsiyonlar);
                            })
                        }else{
                            self.urunForm.opsiyonList = [];
                            self.secilenOpsiyonlar = [];
                            self.secilenlerKlon = JSON.stringify(self.secilenOpsiyonlar);
                        }
                        if (response.data.icerik) {
                            this.urunForm.icerik = htmlDecode(response.data.icerik);
                        }
                        if(response.data.link){
                            this.urunForm.link = response.data.link;
                            this.linkVisible = true
                        }
                        for (var key in response.data) {
                            if (key !== 'resim' && key !== 'icerik') {
                                self.urunForm[key] = response.data[key];
                                self.urunDetayKlon = JSON.stringify(response.data);
                            }
                        }
                    } else {
                        status.Status(response.status, this)
                    }
                })
            },
            kategoriLeftChange(value) {
                let self = this;
                value.forEach(function (e) {
                    self.urunForm.kategoriList.push(e);
                    var item = {
                        durum: 1,
                        kategoriKodu: e
                    };
                    self.updateDataKat.push(item);
                });
            },
            kategoriRightChange(value) {
                let self = this;
                value.forEach(function (e) {
                    let obj = self.urunForm.kategoriList.find(data => data === e);
                    self.urunForm.kategoriList.splice(self.urunForm.kategoriList.indexOf(obj), 1);
                    var item = {
                        durum: 0,
                        kategoriKodu: e
                    };
                    self.updateDataKat.push(item);
                })
            },
            opsiyonChange(value) {
                let self = this;
                this.secilenOpsiyonlar = [];
                for (var y = 0; y < value.length; y++) {
                    if(self.secilenlerKlon.length !== 0){
                        let objK = JSON.parse(self.secilenlerKlon).find(data => data.opsiyonKodu === value[y]);
                        if (objK) {
                            this.secilenOpsiyonlar.push(objK);
                        } else if (objK === undefined) {
                            let obj = self.opsiyonListesi.find(data => data.key === value[y]);
                            self.secilenOpsiyonlar.push({
                                opsiyonKodu: value[y],
                                label: obj.label,
                                aciklama: {
                                    tr: '',
                                    en: '',
                                    de: '',
                                }
                            });
                        }
                    }else{
                        let obj = self.opsiyonListesi.find(data => data.key === value[y]);
                        self.secilenOpsiyonlar.push({
                            opsiyonKodu: value[y],
                            label: obj.label,
                            aciklama: {
                                tr: '',
                                en: '',
                                de: '',
                            }
                        });
                    }

                }
            },
            removeSecilen(index){
                this.secilenOpsiyonlar.splice(index,1);
                this.urunForm.opsiyonList.splice(index, 1);

            },
            seoIcerikTespit() {
                if (this.seoIcerikChange) {
                    const myStr = strip_html_tags(this.urunForm.icerik);
                    this.urunForm.seoIcerik = myStr.substring(0, 140);
                }
            },
            seoIcerikDilTespit() {
                if (this.seoIcerikIngChange) {
                    const myStr = strip_html_tags(this.urunForm.dil.en.icerik);
                    this.urunForm.dil.en.seoIcerik = myStr.substring(0, 140);
                }
            },
            seoIcerikDil2Tespit() {
                if (this.seoIcerikIngChange) {
                    const myStr = strip_html_tags(this.urunForm.dil.de.icerik);
                    this.urunForm.dil.de.seoIcerik = myStr.substring(0, 140);
                }
            },
            // inputStyle(val, form) {
            //     var splitStr = val.toLowerCase().split(' ');
            //     for (var i = 0; i < splitStr.length; i++) {
            //         splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
            //     }
            //     this.urunForm[form] = splitStr.join(' ');
            // },
            firstImage(item) {
                var index = this.imageListMain.indexOf(item);
                this.imageListMain.splice(index, 1);
                this.imageListMain.unshift(item);
                status.Status('success', this, item.name + " ana resim olarak ayarlandı..");
            },
            serverImageUpload(file, fileList) {
                if (file.raw["type"] === 'image/jpeg' || file.raw["type"] === 'image/png') {
                    this.sumResimFonk(file, randomText(13) + '-' + file.name);
                } else {
                    fileList.pop();
                    status.Status('warning', this, 'Yalnızca ".jpeg", ".jpg" ve ".png" uzantılı görsel seçiniz!!');
                }
            },
            serverImageList() {
                var dizi = [];
                urunService.sunucuResim().then((response) => {
                    if (response.status === 200) {
                        response.data.forEach(function (e) {
                            var item = {
                                name: e,
                                url: urunService.imageUrlKucuk + e
                            };
                            dizi.push(item);
                        });
                        this.imageListServer = dizi;
                    }
                })
            },
            imageUploadtoServer(file) {
                if (this.imageListMain.length === 0) {
                    var item = {
                        name: file.name,
                        url: file.url,
                    };
                    this.imageListMain.push(item);
                    updateList(this, 'resim', 1, file.name);
                    status.Status('success', this, file.name + ' resmi eklendi.');
                } else {
                    let obj = this.imageListMain.find(data => data.name === file.name);
                    if (obj === undefined) {
                        item = {
                            name: file.name,
                            url: file.url,
                        };
                        this.imageListMain.push(item);
                        updateList(this, 'resim', 1, file.name);
                        status.Status('success', this, file.name + ' resmi eklendi.');
                    } else {
                        status.Status('warning', this, 'Bu resim zaten mevcut');
                    }
                }
            },
            imageRemove(file) {
                this.imageListMain.splice(this.imageListMain.indexOf(file), 1);
                updateList(this, 'resim', 0, file.name);
            },
            sumResimFonk(file, imgname) {
                const files = file.raw;
                if (files) {
                    const reader = new FileReader();
                    reader.onload = e => {
                        const data = e.target.result;
                        urunService.resimYukle(imgname, data).then((response) => {
                            if (response.status === 200) {
                                var item = {
                                    name: response.data[2].file,
                                    url: urunService.imageUrlKucuk + response.data[2].file
                                }
                            } else {
                                status.Status(response.status, this)
                            }
                        });
                    };
                    reader.readAsDataURL(files);
                }
            },
            imageUpload(file, fileList) {
                fileList.pop();
                if (file.raw["type"] === 'image/jpeg' || file.raw["type"] === 'image/png') {
                    var tip = file.raw["type"].split("/")[1];
                    if (this.urunForm.baslik) {
                        var imgname = randomText(13) + '-' + this.urunForm.link + "." + tip;
                    } else {
                        imgname = randomText(13) + '-' + file.name;
                    }
                    if (this.imageListMain.length === 0) {
                        var item = {
                            name: imgname,
                            url: file.url,
                            id: file.raw.lastModified
                        };
                        this.imageListMain.push(item);
                        this.sumResimFonk(file, imgname);
                        updateList(this, 'resim', 1, imgname);
                    } else {
                        let obj = this.imageListMain.find(data => data.id === file.raw.lastModified);
                        if (obj === undefined) {
                            item = {
                                name: imgname,
                                url: file.url,
                                id: file.raw.lastModified
                            };
                            this.imageListMain.push(item);
                            this.sumResimFonk(file, imgname);
                            updateList(this, 'resim', 1, imgname);
                        } else {
                            status.Status('warning', this, 'Bu resim zaten mevcut');
                        }
                    }
                } else {
                    fileList.pop();
                    status.Status('warning', this, 'Yalnızca ".jpeg", ".jpg" ve ".png" uzantılı görsel seçiniz!!');
                }
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
                $('.el-upload-list__item-delete').click();
                this.visibleSil = false;
            },
            urunGuncelleme(formName) {
                let self = this;
                var klonDizi = [];
                for (var key in JSON.parse(this.urunDetayKlon)) {
                    if (key !== 'resim' && key !== 'dil' && key !== 'belge' && key !== 'kategori' && key !== 'opsiyon') {
                        if (JSON.parse(this.urunDetayKlon)[key] !== this.urunForm[key]) {
                            if (self.urunForm[key]) {
                                var item = {
                                    type: key,
                                    value: self.urunForm[key]
                                };
                                self.updateData.push(item);
                            }
                        }
                    } else if (key === 'dil') {
                        for (var keyDil in JSON.parse(self.urunDetayKlon).dil.en) {
                            if (JSON.parse(self.urunDetayKlon).dil.en[keyDil] !== self.urunForm.dil.en[keyDil]) {
                                if (self.urunForm.dil.en[keyDil]) {
                                    var itemEn = {
                                        type: keyDil,
                                        value: self.urunForm.dil.en[keyDil]
                                    };
                                    self.updateDataEN.push(itemEn);
                                }
                            }
                        }
                        for (var keyDil in JSON.parse(self.urunDetayKlon).dil.de) {
                            if (JSON.parse(self.urunDetayKlon).dil.de[keyDil] !== self.urunForm.dil.de[keyDil]) {
                                if (self.urunForm.dil.de[keyDil]) {
                                    var itemDe = {
                                        type: keyDil,
                                        value: self.urunForm.dil.de[keyDil]
                                    };
                                    self.updateDataDE.push(itemDe);
                                }
                            }
                        }
                        if (self.updateDataEN.length !== 0 || self.updateDataDE.length !== 0) {
                            self.updateData.push({
                                type: "dil",
                                value: {
                                    en: self.updateDataEN,
                                    de: self.updateDataDE,
                                }
                            })
                        }
                    }
                }
                for (var i = 0; i < self.secilenOpsiyonlar.length; i++) {

                    let obj1 = self.oldOpsiyonList.find(data => data.uOpsiyonKodu === self.secilenOpsiyonlar[i].opsiyonKodu);
                    if (obj1 === undefined) {
                        self.updateDataOps.push({
                            durum: 1,
                            opsiyonKodu: self.secilenOpsiyonlar[i].opsiyonKodu,
                            aciklama: {
                                tr: self.secilenOpsiyonlar[i].aciklama.tr,
                                en: self.secilenOpsiyonlar[i].aciklama.en,
                                de: self.secilenOpsiyonlar[i].aciklama.de
                            }
                        });

                    }
                    if(self.secilenlerKlon.length !== 0){
                        let obj2 = JSON.parse(self.secilenlerKlon).find(data => data.opsiyonKodu === self.secilenOpsiyonlar[i].opsiyonKodu);
                        klonDizi.push(obj2);
                        if (obj2) {
                            if (self.secilenOpsiyonlar[i].aciklama.tr !== klonDizi[i].aciklama.tr) {
                                self.updateDataOps.push({
                                    durum: 2,
                                    opsiyonKodu: self.secilenOpsiyonlar[i].opsiyonKodu,
                                    dil: "tr",
                                    aciklama: self.secilenOpsiyonlar[i].aciklama.tr
                                })
                            }
                            if (self.secilenOpsiyonlar[i].aciklama.en !== klonDizi[i].aciklama.en) {
                                self.updateDataOps.push({
                                    durum: 2,
                                    opsiyonKodu: self.secilenOpsiyonlar[i].opsiyonKodu,
                                    dil: "en",
                                    aciklama: self.secilenOpsiyonlar[i].aciklama.en
                                })
                            }
                            if (self.secilenOpsiyonlar[i].aciklama.de !== klonDizi[i].aciklama.de) {
                                self.updateDataOps.push({
                                    durum: 2,
                                    opsiyonKodu: self.secilenOpsiyonlar[i].opsiyonKodu,
                                    dil: "de",
                                    aciklama: self.secilenOpsiyonlar[i].aciklama.de
                                })
                            }
                        }
                    }

                }
                for(var j=0; j< this.oldOpsiyonList.length; j++){
                    let obj0 = self.secilenOpsiyonlar.find(data => data.opsiyonKodu === self.oldOpsiyonList[j].uOpsiyonKodu);
                    if (obj0 === undefined) {
                        self.updateDataOps.push({
                            durum: 0,
                            opsiyonKodu: self.oldOpsiyonList[j].uOpsiyonKodu,
                        })
                    }
                }
                var statusKat = false;
                var statusOps = false;
                console.log(self.updateDataKat);
                console.log(self.updateDataOps);
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        // if (this.updateData.length !== 0 || this.updateDataKat.length !== 0 || this.updateDataOps.length !== 0) {
                            if (self.updateDataKat.length !==0) {
                                urunService.urunKategoriGuncelle(self.updateUrunKodu, self.updateDataKat).then((response) => {
                                    if (response.status === 200) {
                                        statusKat = true;
                                    } else {
                                        status.Status(response.status, self);
                                    }
                                })
                            }else{
                                statusKat = true;
                            }
                            if (self.updateDataOps.length !== 0) {
                                urunService.urunOpsiyonGuncelle(self.updateUrunKodu, self.updateDataOps).then((response) => {
                                    if (response.status === 200) {
                                        statusOps = true;
                                    } else {
                                        status.Status(response.status, self);
                                    }
                                })
                            }
                            else{
                                statusOps = true;
                            }
                            urunService.urunGuncelle(self.updateUrunKodu, self.updateData).then((response) => {
                                if (response.status === 200) {
                                    if(statusKat && statusOps){
                                        status.Status('success', self, 'Ürün başarıyla guncellendi.');
                                        self.$refs[formName].resetFields();
                                        history.back();
                                    }
                                } else if (response.status === 230) {
                                    status.Status('warning', self, 'Bu bilgiler ile kayıtlı bir Ürün zaten mevcut');
                                } else {
                                    status.Status(response.status, self);
                                }
                            })
                        // } else
                        //     status.Status('warning', this, 'Değişiklik yapılmadı!');


                    }
                })
            },
            changeKonum(konum) {
                this.dialogKonum = false;
                this.konumText = "Değiştir";
                switch (konum) {
                    case '0' :
                        status.Status('success', this, 'Opsiyon konumu "Tab" olarak seçildi.');
                        break;
                    case '1' :
                        status.Status('success', this, 'Opsiyon konumu "Sağ" olarak seçildi.');
                        break;
                }
            }
        }
    }

    function htmlDecode(input) {
        var e = document.createElement('div');
        e.innerHTML = input;
        return e.childNodes[0].nodeValue;
    }

    function updateList(self, type, durum, name) {
        var item = {
            type: type,
            value: [{
                durum: durum,
                [type]: name
            }]
        };
        self.updateData.push(item);
    }

    function strip_html_tags(str) {
        str = str.replace(/&nbsp;/gi, '');
        if ((str === null) || (str === ''))
            return false;
        else
            str = str.toString();
        return str.replace(/<[^>]*>/g, '');
    }

    function randomText(length) {
        let today = new Date();
        let day = today.getDate();
        let mounth = (today.getMonth() + 1);
        let year = today.getFullYear();
        let bugun = year + '' + (mounth <= 9 ? '0' + mounth : mounth) + '' + (day <= 9 ? '0' + day : day);

        var text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

        for (var i = 0; i < length; i++)
            text += possible.charAt(Math.floor(Math.random() * possible.length));
        return bugun + "-" + text;
    }
</script>
<style scoped>
    #affix-container.tabStyle {
        position: relative;
        padding-left: 55px;
        left: -30px;
    }

    .cop {
        color: #ec205f;
        position: relative;
        float: right;
        right: 15px;
        bottom: 10px;
        font-size: 20px;
    }
</style>
<style lang="scss" scoped>
    @import '../../../assets/scss/_variables';

    .aciklamaSpan {
        position: absolute;
        top: 25px;
    }

    .page-table {
        &.overflow {
            overflow: hidden;
        }

        .table-box {
            overflow: hidden;
        }
    }

    .el-form-item {
        font-weight: bold;
    }

</style>

